// extracted by mini-css-extract-plugin
export var equalColumn = "_hq-0";